// MyBookings Page
export default function MyBookings() { return <div><h1 className="text-3xl font-bold">My Bookings</h1><p className="mt-4">View your class bookings.</p></div>; }